/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useMessages, useOccupancy } from '@ably/chat/react';
import { ChatMessageEventType } from '@ably/chat';
import { MentionsInput, Mention } from 'react-mentions';
import EmojiPicker from 'emoji-picker-react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as chatActions from '../store/Chat.action';
import * as myTodoActions from '../../Dashboard/TodoList/MyTodo/store/my-todo.action.ts';
import { filePreview, pageSize } from '../../../Components/helper';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import Loader from '../../../Components/Utility/Loader/Loader';
import useChatNotifications from '../../../hooks/useChatNotifications';
import noImage from '../../../assets/images/no-image.png';
import './ChatMessages.css';

const sortMessagesByCreatedAt = (list = []) => [...list].sort((a, b) => (new Date(a?.createdAt).getTime() || 0) - (new Date(b?.createdAt).getTime() || 0));

const S3_PUBLIC_BASE_URL = `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com`;

const mergeUniqueMessages = (b = []) => {
  const map = new Map();
  [...b].forEach((m) => {
    if (!m) return;
    const k = m.serial || m.id;
    if (!k) return;
    map.set(k, m);
  });
  return sortMessagesByCreatedAt(Array.from(map.values()));
};

const applyEventToMessages = (prev, event) => {
  const msg = event.message;
  const serial = msg.serial || msg.id;
  if (!serial) return prev;

  if (event.type === ChatMessageEventType.Created) {
    const exists = prev.some((m) => (m.serial || m.id) === serial);
    return exists ? prev : [...prev, msg];
  }
  if (event.type === ChatMessageEventType.Updated) {
    return prev.map((m) => {
      if ((m.serial || m.id) === serial) {
        // Preserve original createdAt timestamp to maintain message order
        return { ...msg, createdAt: m.createdAt || msg.createdAt };
      }
      return m;
    });
  }
  if (event.type === ChatMessageEventType.Deleted) {
    return prev.filter((m) => (m.serial || m.id) !== serial);
  }

  return prev;
};

const getModuleNameByModuleKey = (moduleKey) => {
  switch (moduleKey) {
    case 'Costing':
      return 'Costing';
    case 'samples':
      return 'Samples';
    case 'placeholder':
      return moduleKey;
    case 'BOM':
      return 'BOM';
    case 'SPEC':
      return 'SPEC';
    case 'TESTING':
      return 'TESTING';
    case 'DESIGN_DETAIL':
      return 'DESIGN_DETAIL';
    case 'CARE_USER_INSTRUCTION':
      return 'CARE_USER_INSTRUCTION';
    case 'ProductInfoList':
      return 'ProductInfoList';
    case 'PURCHASE_ORDER':
      return 'PURCHASE_ORDER';
    default:
      return 'chat';
  }
};

function ChatMessages({
  currentUser = {},
  roomName = '',
  moduleRefId = null,
  supplierId = null,
  searchedText = '',
  mentionsUsers = [],
  productDetails = null,
  onResetSamples = null,
  onCloseChat = null,
  moduleKey = 'samples',
}) {
  const { t } = useTranslation('modules/chat');
  const containerRef = useRef(null);
  const params = useParams();
  const devOrderId = params?.devOrderId;
  const [state, setState] = useState({
    messageText: '',
    messages: [],
    showEmojiPicker: false,
    showDeleteConfirm: false,
    messageToDelete: null,
    isDeletingMessage: false,
    editingMessageSerial: null,
    editText: '',
    isLoading: false,
    isSending: false,
    isSavingEdit: false,
    // Load more state
    currentPage: 1,
    hasMoreMessages: true,
    isLoadingMore: false,
    isLoadingOlderMessages: false,
    mentionError: null,
  });
  const {
    messageText,
    messages,
    showEmojiPicker,
    showDeleteConfirm,
    messageToDelete,
    editingMessageSerial,
    editText,
    isLoading,
    isSending,
    isSavingEdit,
    isDeletingMessage,
    currentPage,
    hasMoreMessages,
    isLoadingMore,
    isLoadingOlderMessages,
    mentionError,
  } = state;

  const emojiPickerRef = useRef(null);
  const messageInputRef = useRef(null);
  const dispatch = useDispatch();
  const focusComposer = React.useCallback(() => {
    window.requestAnimationFrame(() => {
      const el = messageInputRef.current;
      if (el && typeof el.focus === 'function') {
        el.focus();
        try {
          if (typeof el.setSelectionRange === 'function') {
            const len = el.value?.length ?? 0;
            el.setSelectionRange(len, len);
          }
        } catch (_e) {
          /* ignore */
        }
      }
    });
  }, []);

  const renderMessageContent = (rawContent) => {
    const text = String(rawContent || '');
    const mentionPattern = /(@[A-Za-z][A-Za-z'’-]*(?:\s+[A-Za-z][A-Za-z'’-]*)?)/g;
    const segments = text.split(mentionPattern);
    return segments.map((segment, index) => {
      if (segment?.startsWith('@')) {
        return (
          <span key={`mention-${index}`} className="mention">
            {segment}
          </span>
        );
      }
      return segment;
    });
  };

  let userId = currentUser?.userId;
  if (currentUser?.supplierUserId) {
    userId = currentUser?.supplierUserId;
  }
  useChatNotifications(userId, roomName, moduleRefId);
  const updateMessages = (updater) => {
    setState((prev) => ({ ...prev, messages: updater(prev.messages) }));
  };

  const canLoadMessages = (isInitialLoad) => {
    if (isInitialLoad) return !!roomName;
    return !isLoadingMore && hasMoreMessages && roomName;
  };

  const updatePaginationState = (resp, pageToLoad) => {
    const pagination = resp?.data?.pagination;
    if (pagination) {
      console.log(`📄 Pagination: ${pagination.currentPage}/${pagination.totalPages}`);
      setState((prev) => ({
        ...prev,
        currentPage: pagination.currentPage,
        hasMoreMessages: pagination.currentPage < pagination.totalPages,
      }));
      return;
    }

    const groups = resp?.data?.messageGroups;
    const rawList = Array.isArray(groups) ? groups.flatMap((g) => g?.messages || []) : resp?.data?.messages || [];

    if (rawList.length === 0 || rawList.length < pageSize) {
      setState((prev) => ({ ...prev, hasMoreMessages: false }));
    } else {
      setState((prev) => ({ ...prev, currentPage: pageToLoad }));
    }
  };

  const mapMessageData = (rawList) => {
    return rawList.map((m) => ({
      id: m?._id,
      serial: m?.serial,
      clientId: String(m?.createdBy?._id || m?.createdBy || ''),
      text: m?.message,
      data: { text: m?.message },
      headers: m?.headers || {},
      createdBy: m?.createdBy,
      timestamp: m?.createdAt || m?.timestamp || new Date().toISOString(),
      isDeleted: m?.isDeleted,
      isEdited: m?.isEdited,
      createdAt: m?.createdAt,
      updatedAt: m?.updatedAt,
    }));
  };

  const handleMessagesUpdate = (mapped, isInitialLoad) => {
    if (isInitialLoad) {
      console.log(`✅ Initial load: ${mapped.length} messages loaded`);
      setState((prev) => ({ ...prev, messages: sortMessagesByCreatedAt(mapped) }));
      return;
    }

    console.log(`✅ Adding ${mapped.length} older messages to the top`);
    const container = containerRef.current;
    const currentScrollTop = container?.scrollTop || 0;
    const currentScrollHeight = container?.scrollHeight || 0;

    setState((prev) => ({
      ...prev,
      messages: sortMessagesByCreatedAt([...mapped, ...prev.messages]),
    }));

    // Maintain scroll position
    setTimeout(() => {
      if (container) {
        const scrollDifference = container.scrollHeight - currentScrollHeight;
        container.scrollTop = currentScrollTop + scrollDifference;
      }
    }, 0);
  };

  const loadMoreMessages = async (isInitialLoad = false) => {
    if (!canLoadMessages(isInitialLoad)) return;

    const pageToLoad = isInitialLoad ? 1 : currentPage + 1;
    console.log(`🔄 Loading messages - Page ${pageToLoad} ${isInitialLoad ? '(Initial)' : '(Load More)'}`);

    setState((prev) => ({
      ...prev,
      isLoadingMore: true,
      isLoadingOlderMessages: !isInitialLoad,
    }));

    try {
      const resp = await dispatch(
        chatActions.fetchChatMessages({
          roomName,
          supplierId,
          moduleRefId,
          pageSize,
          page: pageToLoad,
          isScrolled: !isInitialLoad,
          searchedText,
          searchText: searchedText,
        }),
      );

      updatePaginationState(resp, pageToLoad);

      const groups = resp?.data?.messageGroups;
      const rawList = Array.isArray(groups) ? groups.flatMap((g) => g?.messages || []) : resp?.data?.messages || [];

      if (rawList.length > 0) {
        const mapped = mapMessageData(rawList);
        handleMessagesUpdate(mapped, isInitialLoad);
      } else {
        console.log('⚠️ No messages received from API');
        if (isInitialLoad) {
          setState((prev) => ({ ...prev, messages: [] }));
        }
      }
    } catch (error) {
      console.error('Failed to load more messages:', error);
    } finally {
      setState((prev) => ({
        ...prev,
        isLoadingMore: false,
        isLoadingOlderMessages: false,
      }));
    }
  };

  const handleLoadMore = () => {
    loadMoreMessages(false);
  };

  useOccupancy({
    onRoomStatusChange: (roomStatusChange) => {
      console.log('Room status change:', roomStatusChange);
    },
  });

  const {
    sendMessage,
    updateMessage,
    messages: hookMessages,
  } = useMessages({
    listener: (event) => {
      const headerRefId = event?.message?.headers?.refId;

      if (String(headerRefId) !== String(moduleRefId)) {
        return;
      }

      if (!event?.message) return;
      const normalizedMessage = { ...event.message };
      if (normalizedMessage?.headers?.supplierUserId) {
        normalizedMessage.clientId = String(normalizedMessage.headers.supplierUserId);
      }
      updateMessages((prev) => {
        return sortMessagesByCreatedAt(applyEventToMessages(prev, { ...event, message: normalizedMessage }));
      });
    },
  });

  useEffect(() => {
    if (!roomName) return;

    setState((prev) => ({
      ...prev,
      messages: [],
      currentPage: 1,
      hasMoreMessages: true,
      isLoadingMore: false,
      isLoadingOlderMessages: false,
    }));

    return () => {
      setState((prev) => ({ ...prev, messages: [] }));
    };
  }, [roomName]);

  useEffect(() => {
    let cancelled = false;
    const loadServerMessages = async () => {
      if (!roomName) return;
      try {
        setState((prev) => ({ ...prev, isLoading: true }));
        const resp = await dispatch(
          chatActions.fetchChatMessages({
            roomName,
            supplierId,
            moduleRefId,
            pageSize,
            page: 1,
            searchedText,
            searchText: searchedText,
          }),
        );
        const pagination = resp?.data?.pagination;
        if (pagination) {
          console.log(`📄 Pagination: ${pagination.currentPage}/${pagination.totalPages}`);
          setState((prev) => ({
            ...prev,
            currentPage: pagination.currentPage,
            hasMoreMessages: pagination.currentPage < pagination.totalPages,
          }));
        } else {
          // Fallback if no pagination object
          const initGroups = resp?.data?.messageGroups;
          const initRawList = Array.isArray(initGroups) ? initGroups.flatMap((g) => g?.messages || []) : resp?.data?.messages || [];
          console.log(`📄 Fallback pagination: loaded ${initRawList.length} messages`);
          setState((prev) => ({
            ...prev,
            currentPage: 1,
            hasMoreMessages: !(initRawList.length === 0 || initRawList.length < pageSize),
          }));
        }
        // Support new grouped format, fallback to legacy flat array
        const groups = resp?.data?.messageGroups;
        const rawList = Array.isArray(groups) ? groups.flatMap((g) => g?.messages || []) : resp?.data?.messages || [];

        const mapped = rawList.map((m) => ({
          id: m?._id,
          serial: m?.serial,
          clientId: String(m?.createdBy?._id || m?.createdBy || ''),
          text: m?.message,
          data: { text: m?.message },
          headers: m?.headers || {},
          createdBy: m?.createdBy,
          timestamp: m?.createdAt || m?.timestamp || new Date().toISOString(),
          isDeleted: m?.isDeleted,
          isEdited: m?.isEdited,
          createdAt: m?.createdAt,
          updatedAt: m?.updatedAt,
        }));
        if (!cancelled) {
          // When searching, replace the list entirely; otherwise merge/hydrate
          if (mapped.length > 0) {
            if (searchedText && String(searchedText).trim().length > 0) {
              setState((prev) => ({ ...prev, messages: sortMessagesByCreatedAt(mapped) }));
            } else {
              updateMessages(() => sortMessagesByCreatedAt(mergeUniqueMessages(mapped)));
            }
          } else {
            setState((prev) => ({ ...prev, messages: [] }));
          }
        }
      } catch (_e) {
        // ignore
      } finally {
        if (!cancelled) {
          setState((prev) => ({ ...prev, isLoading: false }));
        }
      }
    };
    loadServerMessages();
    return () => {
      cancelled = true;
    };
  }, [roomName, supplierId, moduleRefId, searchedText]);

  useEffect(() => {
    if (Array.isArray(hookMessages) && hookMessages.length > 0) {
      setState((prev) => ({ ...prev, messages: sortMessagesByCreatedAt(hookMessages) }));
    }
  }, [hookMessages]);

  const reduxMessagesList = useSelector((st) => st.ChatDetails?.messagesList);

  useEffect(() => {
    if (!Array.isArray(reduxMessagesList) || reduxMessagesList.length === 0) return;
    if (!Array.isArray(messages) || messages.length === 0) return;
    let lastLocal = null;
    for (let i = messages.length - 1; i >= 0; i -= 1) {
      const m = messages[i];
      const txt = m?.text || m?.data?.text;
      if (!m?.id && txt) {
        lastLocal = m;
        break;
      }
    }
    if (!lastLocal) return;

    const localText = lastLocal.text || lastLocal.data?.text;
    const localTs = new Date(lastLocal?.timestamp || lastLocal?.createdAt || Date.now()).getTime();

    const candidates = reduxMessagesList.filter((m) => (m?.message || m?.text) === localText);
    if (candidates.length === 0) return;

    const target = candidates
      .map((m) => ({
        m,
        diff: Math.abs(new Date(m?.createdAt || m?.timestamp || Date.now()).getTime() - localTs),
      }))
      .sort((a, b) => a.diff - b.diff)?.[0]?.m;

    if (!target?._id) return;

    updateMessages((prev) => {
      return prev.map((m) => {
        const sameBySerial = lastLocal?.serial && m?.serial && m.serial === lastLocal.serial;
        const sameByTimeAndText =
          !lastLocal?.serial && (m?.text || m?.data?.text) === localText && new Date(m?.timestamp || m?.createdAt).getTime() === localTs;
        if (!m?.id && (sameBySerial || sameByTimeAndText)) {
          return { ...m, id: target._id };
        }
        return m;
      });
    });
  }, [reduxMessagesList]);

  useEffect(() => {
    return () => {
      setState((prev) => ({ ...prev, messages: [] }));
    };
  }, [roomName]);

  const scrollToBottom = React.useCallback(() => {
    const el = containerRef.current;
    if (!el) return;
    window.requestAnimationFrame(() => {
      el.scrollTop = el.scrollHeight;
    });
  }, []);

  const scrollToBottomSmooth = React.useCallback(() => {
    const el = containerRef.current;
    if (!el) return;
    try {
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    } catch (_e) {
      // Fallback for older browsers
      el.scrollTop = el.scrollHeight;
    }
  }, []);

  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const onScroll = () => {
      const threshold = 60;
      const distanceFromBottom = el.scrollHeight - el.clientHeight - el.scrollTop;
      const hasScrollbar = el.scrollHeight > el.clientHeight;

      const isSearching = searchedText && String(searchedText).trim().length > 0;
      const shouldShowButton = hasScrollbar && distanceFromBottom > threshold && (!isSearching || hasScrollbar);

      setShowScrollToBottom(shouldShowButton);
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    // Run once to initialize
    onScroll();
    return () => el.removeEventListener('scroll', onScroll);
  }, [containerRef, searchedText]);

  useEffect(() => {
    if (messages.length && !isLoadingOlderMessages) {
      scrollToBottom();
    }
  }, [messages.length, scrollToBottom, isLoadingOlderMessages]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    // Use a small delay to ensure DOM has updated after message changes
    const timeoutId = setTimeout(() => {
      const threshold = 60;
      const distanceFromBottom = el.scrollHeight - el.clientHeight - el.scrollTop;
      const hasScrollbar = el.scrollHeight > el.clientHeight;

      const isSearching = searchedText && String(searchedText).trim().length > 0;
      const shouldShowButton = hasScrollbar && distanceFromBottom > threshold && (!isSearching || hasScrollbar);

      setShowScrollToBottom(shouldShowButton);
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [messages, searchedText]);

  const handleSendMessage = async () => {
    if (isSending || !messageText.trim() || !roomName) {
      return;
    }

    const mentionMatches = [...messageText.matchAll(/@\[(.+?)\]\((.+?)\)/g)];
    const hasAllMention = mentionMatches.some((m) => String(m?.[1] ?? '').toLowerCase() === 'all' || String(m?.[2] ?? '').toLowerCase() === 'all');

    // Specific user mentions (excluding "all")
    const specificMentions = mentionMatches.filter(
      (m) => String(m?.[1] ?? '').toLowerCase() !== 'all' && String(m?.[2] ?? '').toLowerCase() !== 'all',
    );

    // Validate all specific mentions resolve to a known user
    const validUserIds = new Set((mentionsUsers || []).map((u) => u.id));
    const unresolvableMentions = specificMentions.filter((m) => !validUserIds.has(m[2]));
    if (unresolvableMentions.length > 0) {
      setState((prev) => ({
        ...prev,
        mentionError: `Cannot find user: ${unresolvableMentions.map((m) => m[1]).join(', ')}`,
      }));
      return;
    }

    setState((prev) => ({ ...prev, mentionError: null }));

    try {
      setState((prev) => ({ ...prev, isSending: true }));

      let mentions = [];
      if (hasAllMention) {
        const allMentionUsers = mentionsUsers.filter((u) => u?.id !== 'all');
        mentions = Array.isArray(allMentionUsers) ? allMentionUsers.map((u) => ({ id: u?.id, display: u?.display })) : [];
      } else {
        mentions = mentionMatches.map((m) => ({ id: m[2], display: m[1] }));
      }
      mentions = Array.from(new Map(mentions.map((x) => [x.id, x])).values());

      const plainMessage = messageText.replace(/@\[(.+?)\]\(.+?\)/g, '@$1');

      // Auto-create todos for each uniquely mentioned user (excluding "all")
      const uniqueSpecificMentions = Array.from(new Map(specificMentions.map((m) => [m[2], m])).values());
      if (uniqueSpecificMentions.length > 0) {
        const todoPromises = uniqueSpecificMentions.map((mention) => {
          const todoData = {
            assignedTo: mention[2],
            assignedBy: currentUser?.userId,
            assignedByName: `${currentUser?.firstName || ''} ${currentUser?.lastName || ''}`.trim(),
            status: 'Pending',
            location: getLocationFromModuleKey(moduleKey),
            moduleRefId,
            devOrderId: devOrderId || null,
            description: plainMessage.trim(),
            assignedAt: new Date().toISOString(),
          };
          return dispatch(myTodoActions.addMyTodo(todoData));
        });
        await Promise.all(todoPromises);
      }

      const messageWithHeaders = {
        text: plainMessage,
        headers: {
          role: currentUser?.role,
          firstName: currentUser?.firstName,
          lastName: currentUser?.lastName,
          image: currentUser?.image,
          refId: moduleRefId,
          supplierUserId: currentUser?.supplierUserId,
          // Do NOT include arrays/objects here; Ably headers only accept string/number/boolean
        },
      };

      const res = await sendMessage(messageWithHeaders);

      const messageData = {
        moduleRefId: moduleRefId || null,
        room: roomName,
        message: plainMessage.trim(),
        supplierId: supplierId && supplierId !== 'default' ? supplierId : null,
        module: getModuleNameByModuleKey(moduleKey),
        attachments: [],
        serial: res?.serial,
        devOrderId: devOrderId || null,
        clientId: `${currentUser?.userId}_${window.location.hostname.split('.')[0] || 'default'}`,
        mentions,
      };

      const response = await dispatch(chatActions.sendMessage(messageData));

      if (response?.code === 500) {
        if (onCloseChat) {
          onCloseChat();
        }

        if (onResetSamples) {
          onResetSamples();
        }

        setState((prev) => ({ ...prev, messageText: '', isSending: false }));
        return;
      }

      setState((prev) => ({ ...prev, messageText: '', isSending: false }));
      focusComposer();
    } catch (error) {
      console.error('Failed to send message:', error);
      setState((prev) => ({ ...prev, isSending: false }));
      focusComposer();
    }
  };

  const autoCompleteMentionAtEnd = () => {
    try {
      const value = messageText || '';

      const m = value.match(/@([A-Za-z][A-Za-z\s'-]{0,50})$/);
      if (!m || !Array.isArray(mentionsUsers)) return false;
      const typedName = (m[1] || '').trim();
      if (!typedName) return false;
      const match = mentionsUsers.find((u) => (u?.display || '').toLowerCase() === typedName.toLowerCase());
      if (!match) return false;
      const markup = `@[${match.display}](${match.id})`;
      const newVal = value.replace(/@([A-Za-z][A-Za-z\s'-]{0,50})$/, markup);
      setState((prev) => ({ ...prev, messageText: `${newVal} ` }));
      return true;
    } catch (_e) {
      return false;
    }
  };

  const handleEmojiSelect = (emojiData) => {
    setState((prev) => ({ ...prev, messageText: prev.messageText + emojiData.emoji }));
    window.requestAnimationFrame(() => {
      const el = messageInputRef.current;
      if (el && typeof el.focus === 'function') {
        el.focus();
        if (typeof el.setSelectionRange === 'function') {
          const len = el.value?.length ?? 0;
          el.setSelectionRange(len, len);
        }
      }
    });
  };

  const toggleEmojiPicker = () => {
    setState((prev) => ({ ...prev, showEmojiPicker: !prev.showEmojiPicker }));
  };

  const handleDeleteMessage = (message) => {
    if (!message.serial) {
      toasterMsg('Message serial is required for deletion', 'danger');
      return;
    }
    setState((prev) => ({ ...prev, messageToDelete: message.serial, showDeleteConfirm: true }));
  };

  const handleConfirmDelete = async () => {
    if (!messageToDelete || isDeletingMessage) return;

    try {
      setState((prev) => ({ ...prev, isDeletingMessage: true }));
      const deletedText = t('CHAT.MESSAGES.MESSAGE_DELETED_BY_AUTHOR');

      const targetLocal = messages?.find((m) => m?.serial === messageToDelete);
      const targetSerial = targetLocal?.serial;

      if (targetSerial) {
        updateMessage(
          targetSerial,
          {
            text: deletedText,
            headers: {
              role: currentUser?.role,
              firstName: currentUser?.firstName,
              lastName: currentUser?.lastName,
              image: currentUser?.image,
              isDeleted: true,
              supplierUserId: currentUser?.supplierUserId,
              refId: targetLocal?.headers?.refId || moduleRefId,
              updatedAt: new Date().toISOString(),
            },
          },
          { description: 'Message update by user' },
        )
          .then((updatedMsg) => {
            console.log('Message updated:', updatedMsg);
          })
          .catch((error) => {
            console.error('Error updating message: ', error);
          });
      }
      const deleteMessageData = {
        serial: messageToDelete,
        module: getModuleNameByModuleKey(moduleKey),
      };
      await dispatch(chatActions.deleteChatMessage(deleteMessageData));
    } catch (error) {
      console.error('Failed to delete message:', error);
    } finally {
      setState((prev) => ({ ...prev, showDeleteConfirm: false, messageToDelete: null }));
      setTimeout(() => {
        setState((prev) => ({ ...prev, isDeletingMessage: false }));
      }, 500);
    }
  };

  const handleCancelDelete = () => {
    setState((prev) => ({ ...prev, showDeleteConfirm: false, messageToDelete: null }));
  };

  const handleEditMessage = (message) => {
    if (!message.serial) {
      toasterMsg('Message serial is required for editing', 'danger');
      return;
    }
    setState((prev) => ({
      ...prev,
      editingMessageSerial: message.serial,
      editText: message.text || message.data?.text || '',
    }));
  };

  const handleSaveEdit = async (message) => {
    if (isSavingEdit) {
      return;
    }
    if (!editText.trim()) {
      toasterMsg(t('CHAT.VALIDATION.EMPTY_MESSAGE_ERROR'), 'danger');
      return;
    }

    try {
      setState((prev) => ({ ...prev, isSavingEdit: true }));
      if (message.serial) {
        await updateMessage(
          message.serial,
          {
            text: editText.trim(),
            headers: {
              role: currentUser?.role,
              firstName: currentUser?.firstName,
              lastName: currentUser?.lastName,
              image: currentUser?.image,
              supplierUserId: currentUser?.supplierUserId,
              isEdited: true,
              refId: message?.headers?.refId || moduleRefId,
            },
          },
          { description: 'Message edited by user' },
        );
      }
      const editMessageData = {
        message: editText.trim(),
        module: getModuleNameByModuleKey(moduleKey),
        serial: message.serial,
      };
      await dispatch(chatActions.editChatMessage(editMessageData));

      setState((prev) => ({ ...prev, editingMessageSerial: null, editText: '' }));
    } catch (error) {
      console.error('Failed to edit message:', error);
      toasterMsg(t('CHAT.ERROR.UPDATE_FAILED') || 'Failed to update message', 'danger');
    } finally {
      setState((prev) => ({ ...prev, isSavingEdit: false }));
    }
  };

  const handleCancelEdit = () => {
    setState((prev) => ({ ...prev, editingMessageSerial: null, editText: '' }));
  };

  const getLocationFromModuleKey = (moduleKey) => {
    const locationMap = {
      samples: 'Samples',
      Costing: 'Costing',
      BOM: 'BOM',
      SPEC: 'SPEC',
      TESTING: 'Testing',
      DESIGN_DETAIL: 'Design Detail',
      CARE_USER_INSTRUCTION: 'Care User Instruction',
      ProductInfoList: 'Product Information',
      PURCHASE_ORDER: 'Purchase Order',
      placeholder: 'Placeholder',
    };
    return locationMap[moduleKey] || 'Chat';
  };

  const handleEditKeyPress = (e, message) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      if (isSavingEdit) return;
      e.preventDefault();
      handleSaveEdit(message);
    }
    if (e.key === 'Escape') {
      handleCancelEdit();
    }
  };

  const isChatDisabled =
    productDetails?.isArchived === true ||
    (supplierId &&
      supplierId !== 'default' &&
      Array.isArray(productDetails?.suppliers) &&
      productDetails.suppliers.length > 0 &&
      (productDetails?.suppliers[0]?._id
        ? !productDetails.suppliers.map((supplier) => supplier?._id).includes(supplierId)
        : !productDetails.suppliers.includes(supplierId)));
  return (
    <div className="chat-messages-container">
      <div className={`chat-messages-container-inner ${isChatDisabled ? 'chat-disabled' : ''}`}>
        <div ref={containerRef} className="messages-container">
          {hasMoreMessages && !isLoadingMore && messages.length > 0 && (
            <div className="load-more-button-container">
              <button type="button" className="load-more-button" onClick={handleLoadMore} disabled={isLoadingMore}>
                {t('CHAT.ACTIONS.LOAD_MORE')}
              </button>
            </div>
          )}
          {isLoadingMore && (
            <div className="loading-more-messages">
              <div className="text-center">
                <output className="spinner-border spinner-border-sm me-2">
                  <span className="sr-only">Loading...</span>
                </output>
              </div>
            </div>
          )}

          {isLoading && (
            <div className="text-center py-3">
              <Loader />
            </div>
          )}
          {!isLoading && searchedText && String(searchedText).trim().length > 0 && Array.isArray(messages) && messages.length === 0 && (
            <div className="text-center py-4">
              <p className="text-muted">{t('CHAT.SEARCH.NO_RESULTS')}</p>
            </div>
          )}
          {!isLoading && Array.isArray(messages) && messages.length > 0 && (
            <>
              {messages.map((message, index) => {
                let isCurrentUser = false;
                if (currentUser?.supplierUserId) {
                  isCurrentUser = (message?.createdBy?._id || message?.headers?.supplierUserId || message?.clientId) === currentUser?.supplierUserId;
                } else {
                  isCurrentUser = (message?.clientId?.split('_')[0] || message?.createdBy?._id) === currentUser?.userId;
                }
                // Determine the user data for avatar display
                const createdBy = message?.createdBy || message?.headers;

                // Generate initials from firstName and lastName
                const firstName = createdBy?.firstName || '';
                const lastName = createdBy?.lastName || '';
                const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'U';

                // Get user image
                const userImage = createdBy?.image;
                let imageData = null;
                if (userImage?.startsWith('https') || userImage?.startsWith('http')) {
                  imageData = userImage;
                } else {
                  imageData = `${S3_PUBLIC_BASE_URL}/${userImage}`;
                }

                const isDeleted = message?.isDeleted || message?.data?.isDeleted || message?.headers?.isDeleted;
                let content = t('CHAT.MESSAGES.NO_CONTENT');
                if (isDeleted) {
                  content = t('CHAT.MESSAGES.MESSAGE_DELETED_BY_AUTHOR');
                } else if (message.text) {
                  content = message.text;
                } else if (message.data?.text) {
                  content = message.data.text;
                }

                const formatMessageTime = (timestamp) => {
                  const now = new Date();
                  const msgDate = new Date(timestamp);
                  const diffMs = now - msgDate;
                  const diffMin = Math.floor(diffMs / (1000 * 60));
                  const isToday = now.toDateString() === msgDate.toDateString();

                  if (!isToday) {
                    return msgDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
                  }

                  if (diffMin < 1) {
                    return 'Just now';
                  }
                  if (diffMin < 60) {
                    return `${diffMin} min`;
                  }
                  return msgDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
                };
                const formatMessageTimewithDate = (timestamp) => {
                  const now = new Date();
                  const msgDate = new Date(timestamp);
                  const isToday = now.toDateString() === msgDate.toDateString();

                  const timeString = msgDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });

                  if (isToday) {
                    return `Today ${timeString}`;
                  }

                  const day = msgDate.getDate();
                  const month = msgDate.toLocaleString('en-US', { month: 'short' });
                  const year = msgDate.getFullYear();

                  return `${day} ${month} ${year}, ${timeString}`;
                };

                const isSameDay = (aTs, bTs) => {
                  const a = new Date(aTs);
                  const b = new Date(bTs);
                  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
                };

                const formatDateLabel = (timestamp) => {
                  const d = new Date(timestamp);
                  const today = new Date();
                  if (d.toDateString() === today.toDateString()) {
                    return t('CHAT.MESSAGES.TODAY') || 'Today';
                  }
                  return d.toLocaleDateString([], { weekday: 'long', month: 'short', day: 'numeric' });
                };

                const formattedTime = formatMessageTime(message.createdAt);
                const formattedTimeupdatedAt = formatMessageTimewithDate(message?.updatedAt || message?.headers?.updatedAt);
                const prevMsg = messages[index - 1];
                const showDateHeader = !prevMsg || !isSameDay(prevMsg?.timestamp, message?.timestamp);


                return (
                  <React.Fragment key={`msgwrap-${message.serial}`}>
                    {showDateHeader && (
                      <div className="date-separator">
                        <span className="date-separator-text">{formatDateLabel(message.timestamp)}</span>
                      </div>
                    )}
                    <div className={`message-wrapper ${isCurrentUser ? 'current-user' : 'other-user'}`}>
                      <div className="message-row">
                        <div className="message-username">
                          <span>
                            {(message.isEdited || message?.headers?.isEdited) && !isCurrentUser && <span className="message-edited">Edited - </span>}
                            {`${firstName} ${lastName}`.trim() || 'User'}
                            {(message.isEdited || message?.headers?.isEdited) && isCurrentUser && <span className="message-edited"> - Edited</span>}
                          </span>
                          <span className="message-time-inline">{isDeleted ? formattedTimeupdatedAt : formattedTime}</span>
                        </div>
                        <div
                          className={`message-bubble ${isDeleted ? 'deleted-message' : ''}`}
                          style={editingMessageSerial === message.serial ? { padding: 1 } : {}}
                        >
                          {editingMessageSerial === message.serial ? (
                            <div className="message-edit-container">
                              <textarea
                                value={editText}
                                onChange={(e) => setState((prev) => ({ ...prev, editText: e.target.value }))}
                                onKeyPress={(e) => handleEditKeyPress(e, message)}
                                className="message-edit-input"
                                placeholder={t('CHAT.INPUT.EDIT_PLACEHOLDER') || 'Edit your message...'}
                              />
                              <div className="edit-actions">
                                <button
                                  type="button"
                                  onClick={handleCancelEdit}
                                  className="chat-action-button cancel-edit"
                                  aria-label={t('CHAT.ACTIONS.CANCEL') || 'Cancel'}
                                >
                                  <i className="icon-close" />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleSaveEdit(message)}
                                  className="chat-action-button save-edit"
                                  disabled={isSavingEdit}
                                  aria-label={t('CHAT.ACTIONS.SAVE') || 'Save'}
                                >
                                  <i className="icon-Bulk_Update" />
                                </button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="message-text">{renderMessageContent(content || '')}</div>
                              {isCurrentUser && !isDeleted && (
                                <div className="chat-actions">
                                  <button
                                    aria-label={t('CHAT.ACTIONS.EDIT') || 'Edit'}
                                    onClick={() => handleEditMessage(message)}
                                    type="button"
                                    className="chat-action-button"
                                  >
                                    <i className="icon-Edit-1" />
                                  </button>
                                  <button
                                    aria-label={t('CHAT.ACTIONS.DELETE') || 'Delete'}
                                    type="button"
                                    className="chat-action-button"
                                    onClick={() => handleDeleteMessage(message)}
                                  >
                                    <i className="icon-Delete" />
                                  </button>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                        <div className="message-avatar" aria-hidden="true">
                          {imageData ? (
                            <img
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = noImage;
                              }}
                              src={imageData}
                              alt={`${firstName} ${lastName}`.trim() || 'User avatar'}
                              className="avatar-image"
                            />
                          ) : null}
                          <div className="avatar-initials" style={{ display: imageData ? 'none' : 'flex' }}>
                            {initials}
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </>
          )}

          {showScrollToBottom && (
            <div className="scroll-to-bottom-btn-container">
              <button type="button" className="scroll-to-bottom-btn" onClick={scrollToBottomSmooth} aria-label="Scroll to bottom">
                <i className="icon-Sort-CP-desc" />
              </button>
            </div>
          )}
        </div>

        <div className="message-input-container">
          {mentionError && (
            <div className="mention-error-message">
              <i className="icon-Warning" />
              {mentionError}
            </div>
          )}
          <div className="input-wrapper">
            <MentionsInput
              value={isSending ? '' : messageText}
              onChange={(_e, newValue) => setState((prev) => ({ ...prev, messageText: newValue }))}
              disabled={isChatDisabled || isSending}
              inputRef={messageInputRef}
              onKeyDown={(e) => {
                // Try autocomplete on Space/Enter
                if (e.key === ' ' || e.key === 'Enter') {
                  const converted = autoCompleteMentionAtEnd();
                  if (converted && e.key === 'Enter') {
                    e.preventDefault();
                    return; // do not send yet; user just completed the chip
                  }
                }
                if (e.key === 'Enter' && !e.shiftKey && !isSending) {
                  e.preventDefault();
                  handleSendMessage();
                  // ensure focus stays in composer
                  focusComposer();
                }
              }}
              placeholder={t('CHAT.INPUT.PLACEHOLDER')}
              className="message-input"
              classNamePrefix="message-input"
              singleLine={false}
              allowSuggestionsAboveCursor
            >
              <Mention
                trigger="@"
                data={mentionsUsers || []}
                appendSpaceOnAdd
                displayTransform={(_id, display) => `@${display}`}
                markup="@[__display__](__id__)"
                allowSpaceInQuery
                renderSuggestion={(entry) => {
                  const displayVal = entry?.display || '';
                  const parts = displayVal.split(' ');
                  const firstName = entry?.firstName || parts[0] || '';
                  const lastName = entry?.lastName || parts[1] || '';
                  const initials = `${(firstName.charAt(0) || '').toUpperCase()}${(lastName.charAt(0) || '').toUpperCase()}`;
                  const userImage = entry?.image;
                  let imageSrc = null;
                  if (userImage) {
                    imageSrc = userImage.startsWith('http') ? userImage : filePreview(userImage);
                  }
                  return (
                    <div className="chat-mention-item">
                      <span className="chat-mention-at">@</span>
                      <div className="chat-mention-avatar">
                        {imageSrc ? <img src={imageSrc} alt="" /> : <span className="chat-mention-initials">{initials || '@'}</span>}
                      </div>
                      <span className="chat-mention-name">{entry?.display}</span>
                    </div>
                  );
                }}
              />
            </MentionsInput>
            <button type="button" onClick={toggleEmojiPicker} className="emoji-button" aria-label="Open emoji picker" disabled={isChatDisabled}>
              <i className="icon-Chat-Emoji" />
            </button>
            <button type="button" onClick={handleSendMessage} className="send-button" disabled={isSending || isChatDisabled}>
              {isSending ? 'Sending...' : t('CHAT.ACTIONS.SEND')}
            </button>
          </div>

          {showEmojiPicker && (
            <div ref={emojiPickerRef} className="emoji-picker-container">
              <EmojiPicker
                onEmojiClick={handleEmojiSelect}
                width={300}
                height={300}
                previewConfig={{
                  showPreview: false,
                }}
                skinTonesDisabled
                searchDisabled
                suggestedEmojisMode="none"
              />
            </div>
          )}
        </div>
      </div>

      <ConfirmationPopup
        onOpen={showDeleteConfirm}
        onConfirm={() => handleConfirmDelete()}
        title={t('CHAT.CHAT_DELETE.HEADER_TEXT')}
        message={t('CHAT.CHAT_DELETE.CONFIRM_TEXT')}
        secondMessage={t('CHAT.CHAT_DELETE.NOTE')}
        toggle={() => handleCancelDelete()}
        disabledBtn={isDeletingMessage}
      />
    </div>
  );
}
export default ChatMessages;
